export default function scrollToTop() {
	const behavior: ScrollBehavior = 'instant' as ScrollBehavior;
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: behavior,
	});
}
